import { Injectable } from '@angular/core';
import { mergeMap, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import {
  ApiService,
  GET_COMPANY_DETAILS,
  LIST_COMPANIES,
  USER_PERMISSIONS_API,
} from 'src/app/core/api.service';
import { AuthService } from '../core/auth.service';
import { Permissions } from '../shared/model/user';

export class Provider {
  auth_tenant_id: string;
  domains: string[];
  expiration_interval: number;
  id: string;
  type: string;
}

export class Company {
  id: string;
  name: string;
  organization_id: number;
  providers: Provider[];
  tenant_id: string;
}

export class CompanyList {
  items: Company[];
}

@Injectable({
  providedIn: 'root',
})
export class CompanyV2Service {
  constructor(
    private api: ApiService,
    private authService: AuthService
  ) {}

  listCompanies(): Observable<CompanyList> {
    return this.api.get<CompanyList>(LIST_COMPANIES);
  }

  getCompanyDetails(companyId: string | null): Observable<Company> {
    return this.authService.getToken(companyId).pipe(
      take(1),
      mergeMap((token) =>
        this.api.get<Company>(GET_COMPANY_DETAILS(companyId), {
          headers: { Authorization: `Bearer ${token}` },
        })
      )
    );
  }

  getPermissions(companyId: string | null): Observable<Permissions> {
    return this.api.get<Permissions>(
      USER_PERMISSIONS_API('company', companyId)
    );
  }
}
